<template>
	<!-- .card -->
	<div class="card" v-bind="$attrs">

		<!-- .card-header -->
		<div class="card-header d-flex align-items-center
			justify-content-between border-0" 
		v-if="title || $slots.header"  
		:class="header_class">

			<p class="mb-0 h5" v-if="title">
				<i 
				v-if="icon"
				class="text-gray-dark mr-3" 
				:class="icon ? 'fe-'+icon : ''"></i>

				{{title}}
				<slot name="header_title"></slot>
			</p>

			<slot name="header"></slot>

		</div>
		<!-- /.card-header -->

		<!-- .card-body -->
		<div class="card-body px-5" 
		v-if="$slots.default">
			<slot></slot>
		</div>
		<!-- /.card-body -->

		<slot name="body"></slot>

		<!-- .card-footer -->
		<div class="card-footer border-top-0 bg-white p-4" 
		:class="footer_class" 
		v-if="$slots.footer">
			<slot name="footer"></slot>
		</div>
		<!-- /.card-footer -->

	</div>
	<!-- /.card -->
</template>


<script>

	export default {

		props: {
			header_class: {
				type: String,
				default: 'pt-4 pl-5 pb-3'
			},
			
			footer_class: String,
			title: String,
			icon: String
		}

	}

</script>